import { render, staticRenderFns } from "./InstrumentSidebar.vue?vue&type=template&id=764c78ab&scoped=true"
import script from "./InstrumentSidebar.vue?vue&type=script&lang=ts"
export * from "./InstrumentSidebar.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentSidebar.vue?vue&type=style&index=0&id=764c78ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764c78ab",
  null
  
)

export default component.exports